import { render } from "./FrontPageView.vue?vue&type=template&id=78a8f8f2"
import script from "./FrontPageView.vue?vue&type=script&lang=js"
export * from "./FrontPageView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__